import React, { useEffect } from 'react';
import Navbar  from "./components/Navbar/navbar";
import Intro from './components/Intro/intro';
import About from './components/About/About';
import Experience from './components/Experience/experience';
import Skills from './components/Skills/skills';
import Project from './components/Project/project';
import Contact from './components/Contact/contact';
import Footer from './components/Footer/footer';
import Aos from "aos";
import "aos/dist/aos.css"

function App() {
  useEffect(()=>{
    Aos.init();
  },[])

  return (
    <div className="App">
      <Navbar/>
      <Intro/>
      <About/>
      <Experience/>
      <Skills/>
      <Project/>
      <Contact/>
      <Footer/>
      {/* <TestMotion/> */}
    </div>
  );
} 

export default App;
